import { T } from "../../constants/theme";

export default function LoadingSkeleton({ count = 8 }) {
  return (
    <div className="explore-grid">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <div
            className="explore-shimmer"
            style={{ aspectRatio: "3 / 4", borderRadius: 12, background: T.surface }}
          />
          <div className="explore-shimmer" style={{ height: 12, width: "60%", borderRadius: 6, background: T.surface }} />
          <div className="explore-shimmer" style={{ height: 14, width: "80%", borderRadius: 6, background: T.surface }} />
          <div className="explore-shimmer" style={{ height: 14, width: "40%", borderRadius: 6, background: T.surface }} />
        </div>
      ))}
    </div>
  );
}
